import { Injectable } from '@angular/core';
import { HttpGeneralService, StockModuleSettingsParms } from '../../shared';
import { CONFIG } from '../../shared/config';
import { CoverageClass } from '../../hospitalSetup/fhir-test/fhir-test.service';
let TherapeuticCardsUrl = CONFIG.baseUrls.TreatmentCards;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
let PriCompanyCheckListUrl = CONFIG.baseUrls.PriCompanyCheckList;
let fhirUrl = CONFIG.baseUrls.fhirUrl;


export interface TherapeuticCards {

    code: number;
    contractId?: number;
    contractNotRest?: number;
    cardNo?: string;
    patientCode: number;
    startDate?: any;
    endDate: any;
    policyNumber: string;
    eligibilityNo?: number;
    patSharingPercentFromCardFlag?: number;
    inTransferBodiesSerial?: number;
    nphiesEligibilityTransferReference?: any;
    rowStatus?: number;
    crf?: string;
    deb?: string;
    crfFlag?: any
    debFlag?: any
    dataStatus?: number;
    consultation?: number;
    consultationPercentOrValue ?: number;
    servicesPercent ?: number;
    glasessFlag ?: number;
    pregnancyFollowUpFlag ?: number;
    dentalConsultationFlag ?: number;
    dentalServicesFlag ?: number;
}

@Injectable()
export class TherapeuticCardsService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    getTherapeuticCards(id: number) {
        return this.httpGeneralService.get(id, TherapeuticCardsUrl)
    }

    deleteTherapeuticCards(therapeuticCards: TherapeuticCards) {
        return this.httpGeneralService.delete<number>(therapeuticCards.code, TherapeuticCardsUrl)
    }

    UpdateTherapeuticCards(therapeuticCards: TherapeuticCards) {
        return this.httpGeneralService.update<TherapeuticCards>(therapeuticCards.code, therapeuticCards, `${TherapeuticCardsUrl}/UpdateTherapeuticCards`);
    }

    getStockModuleSettings(parms: StockModuleSettingsParms) {
        return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
    }
    getPriCompanyCheckList(obj: any) {
        return this.httpGeneralService.post(obj, `${PriCompanyCheckListUrl}/GetPriCompanyCheckList`);
    }
    addTherapeuticCards(therapeuticCards: TherapeuticCards[]) {
        return this.httpGeneralService.addCollection(therapeuticCards, `${TherapeuticCardsUrl}/addTherapeuticCards`)
    }
    getRegPatCardsValidation(parms: any) {
        return this.httpGeneralService.add(parms, `${stockTransUrl}/GetRegPatCardsValidation`);
    }

    NphiesCoverageClassSave(_CoverageClassList: CoverageClass[]) {
        return this.httpGeneralService.addCollection(_CoverageClassList,  `${TherapeuticCardsUrl}/NphiesCoverageClassSave`)
    }
}
